export const GET_JOBS = 'GET_JOBS';
export const GET_JOB_ID = 'GET_JOBS_ID';
export const CACHE_JOBS = 'CACHE_JOBS';
export const SET_JOBS = 'SET_JOBS';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const CACHE_CATEGORIES = 'CACHE_CATEGORIES';
export const SET_JOBID = 'SET_JOBID';
export const CACHE_JOBID = 'CACHE_JOBID';
export const SET_JOBS_LOADING = 'SET_JOBS_LOADING';
export const SET_JOB_LOADING = 'SET_JOB_LOADING';
export const SET_JOB_COMPANY_ID = 'SET_JOB_COMPANY_ID';
export const CACHE_JOB_COMPANY_ID = 'CACHE_JOB_COMPANY_ID';
export const JOBS_FILTERS = 'JOBS_FILTERS';
